import React, {useEffect, useState} from 'react';
import {ISsqDataDocument} from "../../repositories/SsqDataRepository";
import {getHighlightedTextFromHtml} from "../../util/commonUtils";
import clsx from "clsx";
import {AccountService} from "repositories/AccountService";
import {LanguageService} from "language/LanguageService";
import axios from "axios";
import parse from "html-react-parser";
import SimpleUserProfile from "communitypage/common/SimpleUserProfile";
import {docutil} from "util/docutil";
import img_store_icon_ls from "images/service/store_icon_ls.svg";
import sample_logo_64 from "images/service/sample_logo_64.svg";
import {langutil} from "language/langutil";
import CommunityPostInfo from "communitypage/common/CommunityPostInfo";
import {IfDocCommentInfo} from "models/IfSsqDataDocCommentEntity";
import {loginutil} from "util/loginutil";
import {useLoginInfo} from 'hooks/useLoginInfo';
import {i18ntrans} from "language/i18nkey";
import {useLoginPopup} from "hooks/useLoginPopup";
import {CommentWrap} from "style/CommonStyledComponents";

interface Props {
  accountService?: AccountService;
  ssqDocument: ISsqDataDocument;
  getTranslation: Function;
  languageService: LanguageService;
  clickedTag: Function;
  displayLoginPopup: Function;
  commentList: Array<IfDocCommentInfo>;
}

const SampleDocListItem = (props: Props) => {
  const [tags, setTags] = useState([]);
  const {country, lang} = langutil.splitLangCode(props.languageService.lang());
  const [comment, setComment] = useState([]);
  const loginInfo = useLoginInfo();
  const showLoginPopup = useLoginPopup();

  useEffect(() => {
    axios.get('/api/guest/ssqData/doctaglist/taggrplist', {
      params: {
        docId: props.ssqDocument.id,
        lang: props.languageService.getLanguage()
      }
    }).then((res) => {
      setTags(res?.data || []);
    });

    axios.get('/api/guest/ssqData/doccomment/list', {
      params: {docId: props.ssqDocument.id}
    }).then((res) => {
      setComment(res?.data || []);
    });
  }, []);

  const t = i18ntrans.common;
  return (
    <li onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();

      if (!loginutil.hasDocViewAuth(loginInfo, props.ssqDocument.displayTarget)) {
        if (loginutil.islogin(loginInfo)) {
          loginutil.alertDocView(loginInfo, props.ssqDocument.displayTarget);
        } else {
          showLoginPopup(true);
        }
        return;
      }
      window.open(`/${country}/${lang}/service/sample/document/${props.ssqDocument.id}`, "_blank");
    }}>
      <div className="store-card-body">
        <div className="store-card-header">

          <div className="logo-img">
            <img alt={'blog-img-url'}
              src={!props.ssqDocument.imageUrl ? sample_logo_64 : docutil.isdefaultsamplelogo(props.ssqDocument.imageUrl)
                ? docutil.getdefaultsamplelogourl(props.ssqDocument.imageUrl) : `/uploads/${props.ssqDocument.imageUrl}`}
            />
          </div>
          <div className="tag">
            <span className="sample-kind">
              {props.ssqDocument.docType === "SAMPLE" ?
                <div><img src={img_store_icon_ls} alt="ls-logo"/>{props.getTranslation("I18N_SERVICE_FILTER_SAMPLE")}</div>
                :
                props.getTranslation("I18N_USER_SAMPLE")
              }
            </span>

            {tags.map((tag, index) => (
              <span key={index} className={'cursor-pointer'} onClick={(e) => {
                e.stopPropagation();
                props.clickedTag(tag.tag);
              }}>#{tag?.tag}</span>
            ))}
          </div>
        </div>
        <div className="store-title">
          <p className="title">
            {parse(getHighlightedTextFromHtml(props.ssqDocument.docTitle))}
            {props.ssqDocument.displayTarget == 15 &&
              <span className={clsx("lv-info", "partner-level")}>{t("I18N_COMMON_PARTNER_ONLY")}</span>}
            {props.ssqDocument.displayTarget == 20 &&
              <span className={clsx("lv-info", "lv-worker")}
              >{props.getTranslation("I18N_SOLUTION_EMPLOYEE_ONLY")}</span>
            }
          </p>
        </div>

        <div className="store-version">
          <div className="store-content-item">
            <p className="write-version">
              {parse(getHighlightedTextFromHtml(props.ssqDocument.sampleVersion))}
            </p>
          </div>
        </div>

        <div className="store-content">
          <div className="store-content-item">
            <p className="write-content" onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();

              if (!loginutil.hasDocViewAuth(loginInfo, props.ssqDocument.displayTarget)) {
                if (loginutil.islogin(loginInfo)) {
                  loginutil.alertDocView(loginInfo, props.ssqDocument.displayTarget);
                } else {
                  showLoginPopup(true);
                }
                return;
              }
              window.open(`/${country}/${lang}/service/sample/document/${props.ssqDocument.id}`, "_blank");
            }}>
              {parse(getHighlightedTextFromHtml(props.ssqDocument.docSampleSmry))}
            </p>
            <CommentWrap>
              <div onClick={(e) => {
                e.stopPropagation();
              }}><SimpleUserProfile userId={props.ssqDocument.writerId} highlightedNickName={props.ssqDocument.writerNickname}
                displayLoginPopup={props.displayLoginPopup}
                askUrl={`${window.location.protocol}//${window.location.host}/${country}/${lang}/service/sample/document/${props.ssqDocument.id}`}/>

              </div>
              <CommunityPostInfo type={"list"}
                commentList={comment}
                ssqDocument={props.ssqDocument}
                time={props.ssqDocument.updateTime}
                count={props.ssqDocument.clickCount}
                good={props.ssqDocument.goodCount}
                bad={props.ssqDocument.badCount}></CommunityPostInfo>
            </CommentWrap>
          </div>
        </div>
      </div>
    </li>
  );
};


export default SampleDocListItem;
